import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { appBarHeight } from 'c1ui'

export const C1SnackbarTheme: Components<Theme>['MuiSnackbar'] = {
    styleOverrides: {
        root: ({ ownerState, theme }) => theme.unstable_sx({
            transform: `translateY(${ownerState.anchorOrigin?.vertical === 'top' ? appBarHeight : 0})`,
        }),
    },
}
